<template>
    <div class="home-projects-wrapper">
        <div class="home-projects">
            <b-container class="home-projects-container">
                <h3 v-if="isJACareerApp" tabindex="0" class="home-projects-container__title">
                    My Career Plans
                </h3>
                <h3 v-if="isJAEntrepreApp" tabindex="0" class="home-projects-container__title">
                    My Projects
                </h3>
                <project-delete-modal
                        ref="project_delete_modal"
                        :projectIndex="projectIndexSelected"
                        :projectId="projectIdSelected"
                        v-on:close-delete-modal="closeDeleteProjectModal()"/>
                <project-actions-modal
                        ref="project_actions_modal"
                        :projectIndex="projectIndexSelected"
                        :projectId="projectIdSelected"
                        v-on:open-delete-modal="openDeleteProjectModal()"/>
                <div class="project-status-item" :key="index" v-for="(p, index) in projects">
                    <project-status :index="p.localStorageIndex" :project="p" tabindex="0" role="button"
                                    :show-actions="true" :show-action-sync="!p.sync && !isGuest"
                                    @onSync="onSyncProject"
                                    @onDelete="openModalActions"
                                    @click="openProject(p.localStorageIndex, p.lastStep, p.type)"/>
                </div>
                <div class="home-projects-buttons">
                    <b-button v-if="isJACareerApp" class="btn-start" tabindex="0" block variant="primary" :to="{name: 'js_start_project'}">Start a New Career Plan</b-button>
                    <b-button v-if="isJAEntrepreApp" class="btn-start" tabindex="0" block variant="primary" :to="{name: 'be_start_project'}">Start a New Project</b-button>
                    <b-button class="btn-home" tabindex="0" block variant="outline-primary" :to="{ name: 'Activities' }">Home</b-button>
                    <b-button class="btn-links" tabindex="0" block variant="outline-primary" :to="{ name: 'QuickLinks' }">Quick Links</b-button>
                </div>
            </b-container>
        </div>
    </div>
</template>

<script>
    import {ProjectService} from '../../../core/Services'
    import ProjectStatus from "../../../core/Components/ProjectStatus"
    import ProjectDeleteModal from "../../../core/Components/ProjectDeleteModal"
    import ProjectActionsModal from "../../../core/Components/ProjectActionsModal"
    import {Storage, Project, ConflictSyn} from '../../../core/Utils'

    export default {
        name: "HomeProjects",
         components: {
            ProjectDeleteModal,
            ProjectActionsModal,
            ProjectStatus
        },
        data() {
            return {
                projects: [],
                projectIndexSelected: null,
                projectIdSelected: null,
                styleGuide: {},
                proyectTypeFilter: false,
            }
        },
        mounted() {
            if (this.isJACareerApp) this.proyectTypeFilter=Project.PROJECT_JOB_SHADOW;
            if (this.isJAEntrepreApp) this.proyectTypeFilter=Project.PROJECT_BE_ENTREPRENEURIAL;

            this.projects = this.filterProjects()
            const user = Storage.getUser()

            if (user.id && this.isOnline) {
                ProjectService.getAllProjects(user.id).then(response => {
                    Storage.setAllProjects(response.projects)
                    this.projects = this.filterProjects()
                }).catch(err => {
                    // TODO: handle error
                })

                ProjectService.getProjectMessages(user.id).then(response => {
                    Storage.setProjectMessages(response.messages);
                }).catch(err => {
                    // TODO: handle error
                })
            }
        },
        methods: {
            onSyncProject(project, index) {
                Project.syncProject(project, index, this.isOffline, true).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.projects = Storage.getProjects()
                    }
                })
            },
            openProject(index, lastStep, type) {
                const projectUrl = Project.getProjectURL(index, type, lastStep)
                this.$router.push({...projectUrl})
            },
            openModalActions(project, index) {
                this.projectIndexSelected = index;
                this.projectIdSelected = project.projectId;
                this.$refs.project_actions_modal.$refs["modal"].show()
            },
            openDeleteProjectModal() {
                this.$refs.project_delete_modal.$refs["modal"].show()
            },
            closeDeleteProjectModal() {
                this.projects = Storage.getProjects()
                this.$refs.project_actions_modal.$refs["modal"].hide()
            },
            filterProjects() {
                const projects = Storage.getProjects()
                const result = projects.map((element, index) => {
                    return { ...element, localStorageIndex: index };
                });
                return result.filter(project => this.proyectTypeFilter && project.type === this.proyectTypeFilter);
            }
        }
    }

</script>

<style scoped lang="stylus">
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .home-projects-wrapper
        background-color color-1

        .home-projects
            padding-bottom 3rem
            padding-top 20px

            &-container
                box-shadow(0px 1px 5px color-shadow)
                padding 25px 20px 30px 25px
                border-radius 25px
                background-color color-blank
                margin-top 0px
                width 90%
                max-width none !important

                &__title
                    font font-poppins-semibold
                    font-size 16px
                    color color-dark
                    margin-bottom 20px

            &-buttons
                display flex
                align-items center
                margin-top 50px
                flex-direction column
                row-gap 20px

                .btn
                    width 260px
                    margin 0px auto
                    border 2px solid color-green-light !important
                    padding 12px 0

                .btn-start
                    background-color color-green-light
                    &:hover
                        background-color color-green-dark
                        border 2px solid color-green-dark

                .btn-home
                .btn-links
                    color color-green-light
                    font font-poppins-semibold
                    font-size 16px
                    &:hover
                        background-color color-green-dark !important
                        color color-blank

    ::v-deep
        .project-status-item
            .project-item-status-info-name
                font font-poppins-bold
                font-size 15px
                color color-dark

            .project-item-status-info-type-step
            .project-item-status-info-date
                font-size 13px

    @media (min-width: 768px) and (max-width: 1200px)
        .home-projects
            padding-top 30px !important

            &-container
                max-width initial !important
                width 90% !important

                &__title
                    font-size 18px !important

            &-buttons
                flex-direction row !important
                column-gap 20px

                .btn-start
                    width 320px !important

                .btn-home
                .btn-links
                    width 250px !important

    @media (min-width: 768px)
        ::v-deep
        .project-status-item
            .project-item-status-info-name
                font-size 20px !important

            .project-item-status-info-type-step
            .project-item-status-info-date
                font-size 15px !important

    @media (min-width: 1200px)
        .home-projects-wrapper
            background-color color-blank !important

            .home-projects
                padding-top 36px !important

                &-container
                    max-width initial !important
                    width 65%
                    padding 50px 50px 51px 50px !important

                    &__title
                        font-size 22px !important

                &-buttons
                    flex-direction row !important
                    column-gap 20px

                    .btn
                        width 320px !important
                        height 50px !important
</style>
